import {
  createContext,
  useContext,
  type KeyboardEvent,
  type MouseEvent,
} from 'react';

export interface SelectContext {
  selectedOption: string;
  focusedOptionIndex: number;
  onSelectOption?(event: MouseEvent | KeyboardEvent, value: string): void;
}

const SelectInputContext = createContext<SelectContext>({
  selectedOption: '',
  focusedOptionIndex: -1,
});

export const useSelectContext = () => useContext(SelectInputContext);

export default SelectInputContext;
